import React from 'react';

import { ConfluenceIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <ConfluenceIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useConfluence = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
) =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.CONFLUENCE,
		analyticsName: Products.CONFLUENCE,
		...options,
	});
